import { render, staticRenderFns } from "./ExDrawer.vue?vue&type=template&id=4aa80b6c&scoped=true"
import script from "./ExDrawer.vue?vue&type=script&lang=js"
export * from "./ExDrawer.vue?vue&type=script&lang=js"
import style0 from "./ExDrawer.vue?vue&type=style&index=0&id=4aa80b6c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa80b6c",
  null
  
)

export default component.exports